import { Box } from '@wix/design-system';
import {
  useAnonymous,
  useIsStudioNewUi,
} from '@wix/package-picker-shared-studio';
import { Footer as LoggedInFooter } from '@wix/premium-purchase-platform/@components';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { AnonymousFooterBanner } from './AnonymousFooterBanner';
import s from './PageFooter.scss';

const NEW_UI_FOOTER_PROPS = {
  borderTop: 'none',
  paddingLeft: '0',
  paddingRight: '0',
};

export const PageFooter = () => {
  const { isAnonymous } = useAnonymous();
  const isStudioNewUi = useIsStudioNewUi();

  return (
    <Box
      width="100%"
      direction="vertical"
      className={isStudioNewUi ? s.newUiFooter : undefined}
    >
      {isAnonymous ? (
        <AnonymousFooterBanner />
      ) : (
        <LoggedInFooter
          {...(isStudioNewUi && NEW_UI_FOOTER_PROPS)}
          marginBottom="SP2"
          isLoggedIn={true}
          showScrollToTop={isStudioNewUi}
          onLinkClick={(_, linkCode) => {
            StudioPackagePickerModule.internals.bi.onFooterLinkClick?.({
              linkCode,
            });
          }}
        />
      )}
    </Box>
  );
};
